export interface IRole {
    id: string;
    name: string;
}
export enum Role {
    Admin = "Admin", 
    CrimeSecurityTeam = "CrimeSecurityTeam", 
    SecurityGuard = "SecurityGuard", 
    Colleague = "Colleague", 
    Manager = "Manager"
}

export type UserRoles = IRole[];